<template>
  <div>
    <div id="suspension" v-show="isShowDialog">
      <div
        :style="{
          height: '100%',
          background: datas.backColor,
          'padding-top': datas.paddingTop + 'px',
          'padding-bottom': datas.paddingBottom + 'px',
          'padding-left': datas.paddingLeft + 'px',
          'padding-right': datas.paddingRight + 'px',
          'border-style': datas.borderStyle,
          'border-color': datas.borderColor,
          'border-width': datas.borderLineWeight + 'px',
          'border-radius': datas.borderRadius + 'px',
          'margin-top': datas.marginTop + 'px',
          'margin-bottom': datas.marginBottom + 'px',
          'margin-left': datas.marginLeft + 'px',
          'margin-right': datas.marginRight + 'px',
        }"
      >
        <!-- 无图片 -->
        <div v-if="!imageList[0]" class="empty_con">
          <img src="@/assets/images/defaultPic2.png" alt="" />
        </div>

        <div v-if="imageList[0]" class="swiper-container">
          <div :class="'swiper-wrapper type1'">
            <!-- <div class="swiper-wrapper type1"> -->
            <div
              v-for="(item, index) in imageList"
              :key="index"
              class="swiper-slide"
              @click="handleClickImg(item)"
            >
              <!-- 图片 -->
              <img :src="item.imgUrl" alt="" draggable="false" />
            </div>
          </div>

          <!-- 分页器 -->
          <div class="swiper-pagination" />
        </div>
      </div>
      <div class="close_btn" @click="handleHideDialog">
        <img src="@/assets/images/close_white.png" alt="" />
      </div>
    </div>
    <div class="mask_con" v-show="isShowDialog"></div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import { handleScanCode } from "@/utils";
export default {
  name: "Suspension",
  props: {
    datas: Object,
  },
  data() {
    return {
      isShowDialog: true,
      mySwiper: null,
    };
  },
  computed: {
    /* 图片删除或者增加 */
    imageList() {
      this.addSwiper();
      return this.datas.imageList;
    },
    carouselInterval() {
      console.log("cccccccccccc");
      this.addSwiper();
      return this.datas.carouselInterval;
    },
  },
  watch: {
    carouselInterval() {
      console.log("变了！！！！！");
    },
  },
  methods: {
    /* 创建轮播对象 */
    addSwiper() {
      this.$nextTick(() => {
        if (this.datas.imageList[0]) {
          if (this.mySwiper instanceof Array) {
            this.mySwiper.forEach((element) => {
              element.destroy();
            });
          } else if (this.mySwiper instanceof Object) {
            // 每次重新创建swiper前都要销毁之前存在的轮播   不然轮播会重复
            this.mySwiper.destroy();
          }

          const params = {
            // loop: true,
            slidesPerView: 1,
            // spaceBetween: 17,
            // autoplay: true,
            autoplay: {
              delay: this.datas.carouselInterval,
            },
            pagination: {
              el: ".swiper-pagination",
              type: "bullets",
            },
          };

          this.mySwiper = new Swiper(".swiper-container", params);
        } else {
          if (this.mySwiper instanceof Array) {
            this.mySwiper.forEach((element) => {
              element.destroy();
            });
          }
          // 每次重新创建swiper前都要销毁之前存在的轮播   不然轮播会重复
          if (this.mySwiper instanceof Object) {
            this.mySwiper.destroy();
          }
        }
      });
    },
    handleHideDialog() {
      this.isShowDialog = false;
    },
    handleClickImg(item) {
      if (item.linkType == "scanCode") {
        // 调起微信扫码，扫码取号并自动跳转到扫码信息页面
        handleScanCode();
      } else if (item.linkUrl) {
        window.location.href = item.linkUrl;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#suspension {
  height: 60%;
  position: absolute;
  right: 80px;
  left: 80px;
  top: 15%;
  z-index: 999;
  /* 无图片 */
  .empty_con {
    background: #979797;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      height: 100%;
    }
  }
  ::v-deep {
    // .my-bullet-class {
    //   width: 10px;
    //   height: 10px;
    // background-color: var(--pointColor);

    .swiper-pagination-bullet {
      background-color: #000;
      width: 14px;
      height: 14px;
      // opacity: 1;
      // &.my-bullet-active {
      //   background-color: var(--color);
      //   opacity: 1;
      // }
    }
    // }
  }
  .swiper-container {
    height: 100%;
  }
  .swiper-slide {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .close_btn {
    position: absolute;
    font-size: 34px;
    top: 105%;
    left: 50%;
    transform: translateX(-50%);
    img {
      width: 60px;
      height: 60px;
    }
  }
}
.mask_con {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}
</style>
